import React from 'react';
import styles from './ProgramWeeks.module.scss';
import { CalendarWeek } from './CalendarWeek';
import { Day, locales } from '../../constants';
import { Button } from '@mui/material';
import { buildSlotsForWeek } from '../../utils';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';

import type { AssignedProgram, WithOptionalId } from '../../types';
import type { DraggedWorkoutLocation } from './CalendarWeek';

const texts = locales.en.components.programs.programWeeks;

interface ProgramWeeksProps {
  program: WithOptionalId<AssignedProgram>;
  onAddWorkout: (weekIndex: number, day: Day) => void;
  onEditWorkout: (weekIndex: number, day: Day) => void;
  onRemoveWorkout: (weekIndex: number, day: Day) => void;
  setSelectedWeekIndex: (weekIndex: number) => void;
  onAddWeek: () => void;
  onDuplicateWeek: (weekIndex: number) => void;
  onDeleteWeek: (weekIndex: number) => void;
  onMoveWorkout?: (
    fromWeekIndex: number,
    fromDay: Day,
    toWeekIndex: number,
    toDay: Day,
  ) => void;
  draggingWorkout?: DraggedWorkoutLocation | null;
  setDraggingWorkout?: (value: DraggedWorkoutLocation | null) => void;
}

export const ProgramWeeks: React.FC<ProgramWeeksProps> = ({
  program,
  onAddWorkout,
  onEditWorkout,
  onRemoveWorkout,
  setSelectedWeekIndex,
  onAddWeek,
  onDuplicateWeek,
  onDeleteWeek,
  onMoveWorkout,
  draggingWorkout,
  setDraggingWorkout,
}) => {
  const renderWeek = (weekIndex: number) => {
    return (
      <div className={styles.weekWrapper} key={`week-${weekIndex}`}>
        <div className={styles.header}>
          <span className={styles.text}>
            {texts.week} {weekIndex + 1}
          </span>
        </div>
        <div className={styles.weekContainer}>
          <CalendarWeek
            weekIndex={weekIndex}
            days={buildSlotsForWeek(weekIndex, program, null)}
            onAddWorkout={(w, d) => onAddWorkout(w, d)}
            onEditWorkout={(w, d) => onEditWorkout(w, d)}
            onRemoveProgramItem={(w, d) => onRemoveWorkout(w, d)}
            onDuplicateWeek={(w) => onDuplicateWeek(w)}
            onDeleteWeek={(w) => onDeleteWeek(w)}
            onMoveWorkout={onMoveWorkout}
            draggingWorkout={draggingWorkout}
            setDraggingWorkout={setDraggingWorkout}
          />
        </div>
      </div>
    );
  };

  const renderAddWeekButton = () => {
    return (
      <Button className={styles.addWeekButton} onClick={onAddWeek}>
        <AddBoxOutlinedIcon color="primary" />
        <span className={styles.text}>Add Week</span>
      </Button>
    );
  };

  return (
    <div className={styles.container}>
      {program.programItems.map((_, index) => renderWeek(index))}
      {renderAddWeekButton()}
    </div>
  );
};
